<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                {{today | date:'yyyy'}} &copy; CIIAM
            </div>
            <!--
            <div class="col-md-6">
                <div class="text-md-end footer-links d-none d-sm-block">
                    <a href="javascript:void(0);">Ayuda</a>
                    <a href="javascript:void(0);">Soporte técnico</a>
                </div>
            </div>
            -->
        </div>
    </div>
</footer>